(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!window.smarttiqueDesignMediaBound) {
  window.smarttiqueDesignMediaBound = true;
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects');
    const data = picker?.querySelector('[data-smarttique-media]');
    const product = picker?.closest('product-info');
    if (!data || !product) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    const options = Array.from(picker.querySelectorAll('fieldset, select')).map((control) =>
      control.tagName === 'SELECT' ? control.value : control.querySelector('input:checked')?.value
    );
    const variant = variants.find((item) =>
      item.options.length === options.length && item.options.every((value, index) => value === options[index])
    );
    if (!variant?.mediaId) return;
    const gallery = product.querySelector('media-gallery');
    const mediaId = product.dataset.section + '-' + variant.mediaId;
    requestAnimationFrame(() => {
      if (gallery?.querySelector('[data-media-id="' + mediaId + '"]')) {
        gallery.setActiveMedia?.(mediaId, false);
      }
    });
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
